import React from "react";
import PropTypes from "prop-types";
import { Alert, Badge, Button, LayersTwo01 } from "@opendate-app/setlist";
import { groupOwnValues, joinOwnValues } from "../../../shared/seriesOwnValues";

const SeriesDateSettingsAlert = ({ series, ownValues = series.own_values, onReset, onResetAll }) => {
  const formatting = { currency: series.base_currency_symbol, timeZone: series.venue_time_zone };
  const groups = groupOwnValues(ownValues);
  const joined = (values, side) => joinOwnValues(values, side, formatting);

  if (ownValues.length === 0) {
    return (
      <Alert
        className="series-date-settings-alert"
        color="gray"
        icon={LayersTwo01}
        title={`This date follows the ${series.name} series`}
        description="Anything you change here becomes this date's own value, and series changes won't overwrite it without asking."
      />
    );
  }

  return (
    <Alert
      className="series-date-settings-alert"
      color="warning"
      title="This date has its own settings"
      actions={onResetAll && groups.length >= 2 ? (
        <Button variant="link-color" size="sm" onClick={onResetAll}>Reset all to series</Button>
      ) : undefined}
      description={(
        <span className="series-date-settings-rows">
          <span>{`Everything else follows ${series.name}. These won't change when the series does, unless you choose to update them.`}</span>
          {groups.map(({ label, values }) => (
            <span key={values[0].key} className="series-date-settings-row" data-testid={`own-value-${values[0].key}`}>
              <Badge color="warning" size="sm">Changed from series</Badge>
              <strong>{label}</strong>
              <span>{joined(values, "own")}</span>
              <span className="series-date-settings-series">{`· series: ${joined(values, "series")}`}</span>
              {onReset && (
                <Button variant="link-color" size="sm" aria-label={`Reset ${label} to series`} onClick={() => onReset(values.map((value) => value.key))}>Reset</Button>
              )}
            </span>
          ))}
        </span>
      )}
    />
  );
};

SeriesDateSettingsAlert.propTypes = {
  series: PropTypes.shape({
    name: PropTypes.string.isRequired,
    own_values: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string,
      kind: PropTypes.string.isRequired,
      own: PropTypes.string,
      series: PropTypes.string,
    })).isRequired,
    base_currency_symbol: PropTypes.string,
    venue_time_zone: PropTypes.string,
  }).isRequired,
  ownValues: PropTypes.array,
  onReset: PropTypes.func,
  onResetAll: PropTypes.func,
};

export default SeriesDateSettingsAlert;
